module.exports = __webpack_public_path__ + "static/media/clickhouse.b28cd553.svg";